import type { List } from "~/types/api";
import { ListsRow } from "./lists-row";

type Props = {
  lists: List[];
  activeListId?: number;
  handleListClick: (listId: number, listName: string) => void;
  handleOpenInNewWindow: (listId: number) => void;
};

export const ListsBody = ({
  lists,
  activeListId,
  handleListClick,
  handleOpenInNewWindow,
}: Props) => {
  return (
    <div className="max-h-64 space-y-2 overflow-auto">
      {lists.map((list) => (
        <ListsRow
          key={list.id}
          id={list.id}
          label={list.name}
          isActive={list.id === activeListId}
          onItemClick={handleListClick}
          onOpenInNewWindow={handleOpenInNewWindow}
        />
      ))}
    </div>
  );
};
